module.exports = __webpack_public_path__ + "img/full7-min.ed8cbf71.png";